import { jsx as _jsx } from "react/jsx-runtime";
import { ScrollContainerRefContext } from '#pplx/frontend/apps/ask/layout/page/ScrollContainerRefProviderShared.js';
/**
 *
 * Provides a ref to a scrollable container element to control.
 *
 */
export const ScrollContainerRefProvider = ({ children, scrollContainerRef, }) => {
    return (_jsx(ScrollContainerRefContext.Provider, { value: { scrollContainerRef }, children: children }));
};
//# sourceMappingURL=ScrollContainerRefProvider.js.map